<template>
  <div>
    <div class="btnWrap">
      <button-global
        class="button-new-event"
        :text="isCopyAction ? 'COPY' : 'NEW EVENT'"
        size="small"
        type="positive"
        @eventPassed="addEventDialog"
        :disabled="false"
      />
    </div>
  </div>
</template>

<script>
import ButtonGlobal from '@/components/GlobalComponents/ButtonGlobal'
import { db } from "@/firebase";
const { customAlphabet } = require('nanoid');
const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-';
const nanoid = customAlphabet(alphabet, 5);

export default {
  components: {
    ButtonGlobal,
  },
  name: "CreateEvent",
  props: {
    actionType: {
      required: false,
      type: String,
      default: 'new'
    },
    newEventName: {
      required: false,
      type: String
    },
    numEvents: {
      required: false, 
      type: Number
    },
    eventId: {
      required: false, 
      type: String
    },
    eventName: {
      required: false, 
      type: String
    }
  },
  data() {
    return {
      customerData: {},
      newSiteName: '',
      newCopyEventName: '',
    }
  },
  computed: {
    isCopyAction() {
      return this.actionType === 'copy';
    }
  },
  created() {
    db.ref(`/customers/${this.$customerId}`).once('value', snapshot => {
      this.customerData = snapshot.val();
    })
  },
  methods: {
    async addEventDialog() {
      
      if (this.numEvents == this.customerData.numEvents) {
        return this.$swal("No more events", `You only have room for ${this.numEvents} events`, "warning");
      }
      
      // generate a copy of a selected event, pass its id for database reference copying.
      if(this.isCopyAction) {

        this.$swal({
          title: 'Copying Event:',
          text: this.eventName,
          icon: 'info',
          confirmButtonText: 'Copy',
          showCancelButton: true,
          showCloseButton: false,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            this.newCopyEventName = this.eventName + '(copy)';
            this.newSiteName = this.$customerId + '_' + nanoid(6);
            await this.addEvent(this.newCopyEventName);
            await this.updateEventDataAfterCreation();
          }
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal('Done!', `Your event, ${this.eventName}, has been copied.`, 'success')
              .then(() => {
                this.$emit('event-created', this.newSiteName, this.newCopyEventName)
              })
          }
        })
        return;
      }

      if (this.newEventName) {
        this.$swal({
          title: 'Creating New Event:',
          text: this.newEventName,
          icon: 'info',
          confirmButtonText: 'Confirm',
          showCancelButton: true,
          showCloseButton: false,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            this.newSiteName = this.$customerId + '_' + nanoid(6);
            await this.addEvent(this.newEventName);
            await this.updateEventDataAfterCreation();
          }
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal('Done!', `Your new event, ${this.newEventName}, is created.`, 'success')
              .then(() => {
                this.$emit('event-created', this.newSiteName, this.newEventName)
              })
          }
        })

      } else {
        this.$swal("No event name", "We need a name for your new event", "warning")
      }
    },
    addEvent(eventName) {
      return Promise.all([
        this.addEventEntry(eventName),
        this.copyHotels(),
        this.addHotelsList(),
        this.copyPages(),
        this.createRooms(this.customerData.numGuests)
      ]);
    },
    updateEventDataAfterCreation() {
      return this.updatePages()
    },
    addEventEntry(eventName) {
      return db.ref(`customers/${this.$customerId}/events/${this.newSiteName}`).set(eventName);
    },
    copyHotels() {
      return this.copyFirebaseTree(this.isCopyAction ? `hotels/${this.$customerId}/${this.eventId}` : `newEventTemplate/hotels`, `hotels/${this.$customerId}/${this.newSiteName}`);
    },
    addHotelsList() {
      return db.ref(`hotelsList/${this.$customerId}/${this.newSiteName}`).set(this.customerData.displayName);
    },
    copyPages() {
      return this.copyFirebaseTree(this.isCopyAction ? `pages/${this.$customerId}/${this.eventId}` : `newEventTemplate/pages`, `pages/${this.$customerId}/${this.newSiteName}`);
    },
    updatePages() {
      return db.ref(`pages/${this.$customerId}/${this.newSiteName}/overview`).once("value")
        .then(data => {
          return data.forEach( snapshot => {
            let page = snapshot.val();
            let pageStr = page.path.split('/');
            pageStr[2] = this.newSiteName;
            let newPath = pageStr.join('/');
            return db.ref(`pages/${this.$customerId}/${this.newSiteName}/overview/${pageStr[3]}`).update({path: newPath});
          })
        })
    },
    createRooms(numberOfRooms) {
      let roomPromises = [];
      for (let roomNo = 1; roomNo <= numberOfRooms; roomNo++) {
        const roomObject = {
          available: true,
          email: "",
          guestID: "",
          guestlastname: "",
          guestname: "",
          phone: "",
          roomnumber: roomNo.toString(),
          sortingNumber: roomNo
        };
        roomPromises.push(db.ref(`rooms/${this.$customerId}/${this.newSiteName}`).push(roomObject));
      }
      return Promise.all(roomPromises);
    },
    copyFirebaseTree(oldRef, newRef) {
      return db.ref(oldRef).once('value')
        .then(snapshot => {
          return db.ref(newRef).set(snapshot.val());
        })
        .catch(err => {
          this.$swal("ERROR", `Error creating event: ${err}`, "error");
        })
    },


  }
}
</script>

<style scoped>
.button-new-event {
  margin-right: 10px;
}
</style>